import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  CardHeader,
  CardTitle,
  ButtonGroup,
  CardFooter,
} from "reactstrap";
import DateTime from 'react-datetime'
import ReactSelect from 'components/Form/Select/Select'
import AsyncSelect from 'react-select/async'
import rest from '../../lib/rest'
import rotas from '../../services/rotas'
import useToggle from "../../lib/useToggle"
import Loading from 'lib/loading'
import useForm from "../../lib/useForm"
import Grafico from 'components/Graficos/Graficos'
import Home from 'components/Graficos/home'
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import './style.css'

const inicialForm = {
  filial_id       : [],
  filialSelect    : [],
  categoria_id    : [],
  categoriaSelect : [],
  data_inicio     : '',
  data_final      : '',
  tipoGrafico     : {id : 7, title : "Estatística Semanal"}
}

const inicialTipoGrafico = [
  {id : 0, title : "Gráfico Por Loja"},
  {id : 1, title : "Gráfico Por Forma de Pagamento"},
  {id : 2, title : "Gráfico Por Vendedor"},
  {id : 3, title : "Gráfico Por Categoria"},
  {id : 4, title : "Gráfico Por Forma de Pagamento Por Lojas"},
  {id : 5, title : "Gráfico Por Loja Mês a Mês"},
  {id : 6, title : "Gráfico Por Hora"},
  {id : 7, title : "Estatística Semanal"},
  {id : 8, title : "Gráfico De Venda Farmácia Popular"},
  {id : 9, title : "Gráfico Por CMV"},
  {id : 10, title : "Gráfico De Desconto Por Vendedor"},
]

const listaGrafico = [
  {
    fonte: '/webgestor/api/graficos/graficoVendaPorLoja.php',
    title: 'Vendas por Lojas',
    optGrafico: false,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoFormaDePagamento.php',
    title: 'Vendas Por Forma de Pagamento',
    optGrafico: false,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaPorVendedor.php',
    title: 'Vendas Por Vendedor',
    optGrafico: false,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaPorCategoria.php',
    title: 'Vendas Por Categoria',
    optGrafico: true,
    color: 'text-blue',
    filtroCat: false
  },
  {
    fonte: '/webgestor/api/graficos/graficoFormaDePagamentoLoja.php',
    title: 'Vendas Por Forma de Pagamento Por Lojas',
    optGrafico: true,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVenda12meses.php',
    title: 'Vendas Por Lojas Mês a Mês',
    optGrafico: true,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaPorHora.php',
    title: 'Vendas Por Hora',
    optGrafico: true,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaPorDiadaSemana.php',
    title: 'Estatística Semanal',
    optGrafico: false,
    color: 'text-blue',
    tipo: 'home',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaFarmaciaPopular.php',
    title: 'Venda De Farmácia Popular',
    optGrafico: true,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaCMV.php',
    title: 'Vendas Por CMV',
    optGrafico: true,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
  {
    fonte: '/webgestor/api/graficos/graficoVendaPorVendedorDesconto.php',
    title: 'Desconto por Vendedor',
    optGrafico: false,
    color: 'text-blue',
    tipo: 'grafico',
    filtroCat: true
  },
]

// const inicialDadosGrafico = {lojas:['nenhuma'], valores: ['0'], total: ['0']}
const inicialDadosGrafico = {semana:[], dia: [], total: []}

const Vendas = () => {

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)
  const [loading, setLoading]                                   = useState(true)
  const [tipoGrafico, setTipoGrafico]                           = useState('BarrasCard')
  const [listaTipoGrafico, setListaTipoGrafico]                 = useState(inicialTipoGrafico)
  const [grafico, setGrafico]                                   = useState(inicialForm)
  const [dadosGrafico, setDadosGrafico]                         = useState(inicialDadosGrafico)
  const [listaLoja, setListaLoja]                               = useState([])
  const [selectlojas, setSelectlojas]                           = useState(false)
  const [hiddenOptGrafico, setHiddenOptGrafico]                 = useState(false);
  const [listaCategoria, setListaCategoria]                     = useState([])
  const [selectCategorias, setSelectCategorias]                 = useState(false)
  
// const pdfConverter = require("jspdf");


  const buscaDados = () => {
    // console.log(form)
    setLoading(true)
    const url = listaGrafico[form.tipoGrafico.id].fonte
    try{
      const retorno = rest.post(url, form)
      retorno.then(ret => {
        console.log(ret)
        if (ret.success && ret.success == 'S'){
          //  console.log(ret.lista)
          setDadosGrafico(ret.lista)
        }else{
          setDadosGrafico(inicialDadosGrafico)
        }
        setLoading(false)
      })

    }catch(err){
      console.log(err)
    }
  }

  const listaLojas = () => {
    // let lista = [{id: 0, title: 'TODAS'}]
    let lista = []
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setListaLoja(lista)
        }
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  const listaCategorias = () => {
    let lista = []
    const url = rotas.categoriaSelect
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"id":ret.lista[i].categoria_id, "title":ret.lista[i].categoria}
          }
          setListaCategoria(lista)
        }
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  // imprimir chat, deixar pra proxima versão
  // const imprimir = (e) => {

  //   console.log(dadosGrafico);

  //   let input = window.document.getElementsByClassName("imprimirPDF")[0];

  //   html2canvas(input).then(canvas => {
  //     const img   = canvas.toDataURL("image/png");
  //     const pdf   = new jsPDF("l", "pt",'A4');

  //     var width   = pdf.internal.pageSize.getWidth();
  //     var height  = pdf.internal.pageSize.getHeight();

  //     pdf.setFontSize(20);
  //     pdf.text(e, 50, 50)
  //     pdf.addImage(
  //       img,
  //       "png",
  //       10,
  //       100,
  //       width - 20,
  //       0
  //     );
      
  //     // tabela de valores
  //     // const headers = [["NAME", "PROFESSION"]];
  //     // const data = this.state.people.map(elt=> [elt.name, elt.profession]);

  //     // let content = {
  //     //   startY: 50,
  //     //   head: headers,
  //     //   body: data
  //     // };
  //     // pdf.autoTable(content);

  //     pdf.save("chart.pdf");
  //   });
  // };

  const handleSubmit = (evt) => {
    if(evt){
      evt.preventDefault()
    }

    if(form.tipoGrafico.id === 5){
      setTipoGrafico('BarrasMes')
    }

    buscaDados()
    setGrafico(form)

  }

  const handleGrafico = (evt) => {
    let selectGrafico = evt.target.value
    setTipoGrafico(selectGrafico)
  }

  useEffect(() => {
    buscaDados()
    listaLojas()
    listaCategorias()
  }, [])

  useEffect(()=>{
    // console.log(form.tipoGrafico)
    
    if((form.tipoGrafico.id !== 4)&&(form.tipoGrafico.id !== 5)&&(form.tipoGrafico.id !== 6)){
      setTipoGrafico('BarrasCard');
      setHiddenOptGrafico(false);
    }

    if(form.tipoGrafico.id === 4){
      setHiddenOptGrafico(true);
    }

    if(form.tipoGrafico.id === 5){
      setHiddenOptGrafico(true);
    }

    if(form.tipoGrafico.id === 6){
      setTipoGrafico('BarrasHora');
      setHiddenOptGrafico(true);
    }

    if(form.tipoGrafico.id === 8){
      setTipoGrafico('VerticalBar');
      setHiddenOptGrafico(true);
    }

    // if(form.data_inicio !== ""){
      handleSubmit();
    // }

  },[form.tipoGrafico])

  useEffect(()=>{
    if(form.filialSelect === null){
      form.filial = []
    }
  },form.filialSelect)


  if (listaGrafico[grafico.tipoGrafico.id].tipo == 'home') {
    return (
      <>
      <div className="content">
        <Container>        
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>GRÁFICO DE VENDAS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {/* painel do filtro */}
                  <div className="border p-3">
                    <Form onSubmit={handleSubmit}>                
                      <Container>
                        <Row>
                          <Col md='7'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name          = "tipoGrafico"
                                placeholder   = "Selecione o tipo do gráfico"
                                options       = {listaTipoGrafico}
                                defaultValue  = {form.tipoGrafico}
                                onChange      = {onChangeSelect('tipoGrafico')}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
  
                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.data_inicio}
                                onChange      = {onChangeDate('data_inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>
  
                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.data_final}
                                onChange      = {onChangeDate('data_final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>
  
                          <Col md="1" className="">
                            <Button
                              className = "w-100 m-0"
                              type      = "submit"
                              color     = "success"
                              style     = {{ padding: '6px' }}
                            >
                              <i
                                className = "nc-icon nc-zoom-split"
                                style     = {{ fontSize: '25px' }}
                              >
                              </i>
                            </Button>
                          </Col>
  
                        </Row>
                        <Row className="mt-1">
                          <Col md='11'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                multiple
                                isDisabled    = {selectlojas}
                                name          = "lojas"
                                placeholder   = "Selecione a loja"
                                options       = {listaLoja}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.map((x) => x.id) : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>

                          {/* 
                          imprimir chat, deixar pra proxima versão
                          <Col md="1" className="">
                            <Button
                              className = "w-100 m-0"
                              type      = "button"
                              color     = "info"
                              style     = {{ padding: '6px' }}
                              onClick   = {e => imprimir('FATURAMENTO SEMANAL')}
                            >
                              <i
                                className = "fas fa-print"
                                style     = {{ fontSize: '25px' }}
                              >
                              </i>
                            </Button>
                          </Col> */}

                        </Row>
                        <Row className="mt-1" hidden = {listaGrafico[grafico.tipoGrafico.id].filtroCat} >
                          <Col md='11'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                multiple
                                isDisabled    = {selectCategorias}
                                name          = "categorias"
                                placeholder   = "Selecione a categoria"
                                options       = {listaCategoria}
                                defaultValue  = {form.categoriaSelect}
                                onChange      = {onChangeSelect('categoriaSelect')}
                                onClick       = {form.categoriaSelect ? form.categoria = form.categoriaSelect.map((x) => x.id) : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
                        </Row>
  
                      </Container>
                    </Form>
                  </div>
                  <div className='imprimirPDF' >
                    <Home
                      key       = {"grafico" + listaGrafico[grafico.tipoGrafico.id].title}
                      loading   = {loading}
                      title     = {listaGrafico[grafico.tipoGrafico.id].title}
                      color     = 'text-blue'
                      lista     = {dadosGrafico}
                    />
                  </div>
  
                </CardBody>
                <CardFooter>
                  <span style={{color:'#ff0000'}}>* Os totais podem variar entre os gráficos devido a arrendodamento de sistema.</span>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      </>
    )
  } else {
    return (
      <>
      <div className="content">
        <Container>        
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>GRÁFICO DE VENDAS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {/* painel do filtro */}
                  <div className="border p-3">
                    <Form onSubmit={handleSubmit}>                
                      <Container>
                        <Row>
                          <Col md='7'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name        = "tipoGrafico"
                                placeholder = "Selecione o tipo do gráfico"
                                options       = {listaTipoGrafico}
                                defaultValue  = {form.tipoGrafico}
                                onChange      = {onChangeSelect('tipoGrafico')}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
  
                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.data_inicio}
                                onChange      = {onChangeDate('data_inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>
  
                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.data_final}
                                onChange      = {onChangeDate('data_final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>
  
                          <Col md="1" className="">
                            <Button
                              className = "w-100 m-0"
                              type      = "submit"
                              color     = "success"
                              style     = {{ padding: '6px' }}
                            >
                              <i className="nc-icon nc-zoom-split"
                                style = {{ fontSize: '25px' }}
                              >
                              </i>
                            </Button>
                          </Col>
  
                        </Row>
                        <Row className="mt-1">
                          <Col md='11'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                multiple
                                isDisabled    = {selectlojas}
                                name          = "lojas"
                                placeholder   = "Selecione a loja"
                                options       = {listaLoja}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.map((x) => x.id) : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
                          {/* <Col md="1" className="">
                            <Button
                              className = "w-100 m-0"
                              type      = "button"
                              color     = "info"
                              style     = {{ padding: '6px' }}
                              onClick   = {e => imprimir(listaGrafico[grafico.tipoGrafico.id].title)}
                            >
                              <i
                                className = "fas fa-print"
                                style     = {{ fontSize: '25px' }}
                              >
                              </i>
                            </Button>
                          </Col> */}
                        </Row>
                        <Row className="mt-1" hidden = {listaGrafico[grafico.tipoGrafico.id].filtroCat}>
                          <Col md='11'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                multiple
                                isDisabled    = {selectCategorias}
                                name          = "categorias"
                                placeholder   = "Selecione a categoria"
                                options       = {listaCategoria}
                                defaultValue  = {form.categoriaSelect}
                                onChange      = {onChangeSelect('categoriaSelect')}
                                onClick       = {form.categoriaSelect ? form.categoria = form.categoriaSelect.map((x) => x.id) : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
                          
                        </Row>
  
                        {/* <Row className="mt-2">
                          <Col md='4'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name        = "vendedor"
                                placeholder = "Vendedor"
                                options       = {listaVendedores}
                                defaultValue  = {form.vendedorSelect}
                                onChange      = {onChangeSelect('vendedorSelect')}
                                onClick       = {form.vendedorSelect ? form.vendedor_id = form.vendedorSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
  
                          <Col md='3'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name="loja"
                                placeholder="Loja"
                                options       = {listaLojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial_id = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
  
                          
                        </Row> */}
                      </Container>
                    </Form>
                  </div>
  
                  <Col hidden = {listaGrafico[grafico.tipoGrafico.id].optGrafico} md="12" className="p-0 mt-3 text-center">
                    <ButtonGroup aria-label="Tipos de Gráficos" onClick={handleGrafico}>
                      <Button variant="secondary" value='PizzaCard'>Gráfico Pizza</Button>
                      {/* <Button variant="secondary" value='LinhaCard'>Gráfico Linha</Button> */}
                      <Button variant="secondary" value='BarrasCard'>Gráfico Barra</Button>
                    </ButtonGroup>
                  </Col>
  
                  <Col className='imprimirPDF' lg="12" sm="12" key={"col" + listaGrafico[grafico.tipoGrafico.id].title}>
                    <Grafico
                      // key       = {"grafico" + listaGrafico[form.tipoGrafico.id].title}graficografico
                      key       = {"grafico" + listaGrafico[grafico.tipoGrafico.id].title}
                      loading   = {loading}
                      // title     = {listaGrafico[form.tipoGrafico.id].title}
                      title     = {listaGrafico[grafico.tipoGrafico.id].title}
                      color     = 'text-blue'
                      lista     = {dadosGrafico}
                      component = {tipoGrafico}
                    />
                  </Col>
  
                </CardBody>
                <CardFooter>
                  <span style={{color:'#ff0000'}}>* Os totais podem variar entre os gráficos devido a arrendodamento de sistema.</span>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      </>
    );
  }

}

export default Vendas;